import { createMuiTheme } from '@material-ui/core/styles'

export const colors = {
  // Primary Colors
  magellanBlue: '#0071BE',
  magellanDarkBlue: '#003C7A',
  magellanSkyBlue: '#5CC8EB',
  magellanLightBlue: '#E5F6FD',
  magellanLightDarkBlue: '#EEF1F6',
  magellanDarkGray: '#898D8D',
  magellanLightGray: '#DFE1DF',

  // Secondary Colors
  magellanPurple: '#5C068C',
  magellanRubine: '#BB0E83',
  magellanPink: '#EEAAB9',
  magellanLightPink: '#FDEEF1',
  magellanLightPurple: '#F6F1F8',
  magellanDeepGreen: '#005130',
  magellanBrightGreen: '#3F7E25',
  magellanLimeGreen: '#D6DB74',
  magellanLightGreen: '#EFF7EC',
  magellanLightLimeGreen: '#F6F8E3',
  // Accent Colors
  magellanDeepOrange: '#A63A1E',
  magellanBrightOrange: '#E0640E',
  magellanMediumOrange: '#F6B966',
  magellanLightYellow: '#FDF8E2',
  magellanLightOrange: '#FCF3E4',
  // Error/Warnings/Etc.
  magellanRed: '#C8102A',
  magellanLightRed: '#FAECEC',
  // Neutral Colors
  magellanWhite: '#FFFFFF',
  magellanBlack: '#000005',
  magellan90Black: '#121C1F',
  magellan80Black: '#2B3336',
  magellan60Black: '#535B5E',
  magellan50Black: '#6A737B',
  magellan30Black: '#ACB0B4',
  magellan20Black: '#C0C4C7',
  magellan10Black: '#D5D8DA',
  magellan5Black: '#E1E5E8',
  magellan3Black: '#F1F1F1',
  magellan1Black: '#F7F8F8',

  // Primary Colors
  californiaBlue: '#17315A',
  californiaMagenta: '#96368D',
  californiaLinkBlue: '#005198',
  // Secondary Colors
  californiaCyan: '#2d6e8d',
  // Accent Colors
  californiaYellow: '#f9a519',
  californiaGreen: '#47b870',
  // Error/Warnings/Etc.
  californiaRed: '#be4727',
  // Neutral Colors
  californiaGray: '#cbd0dc',

  // DHCS Colors
  // Primary Colors (Including Fonts)
  dhcsWhite: '#FFFFFF',
  dhcsBlack: '#000000',
  dhcsBlue: '#17315A',
  dhcsTeal: '#2D6E8D',
  dhcsTealDark: '#335969',
  // Secondary Colors (Including Fonts)
  dhcsOrange: '#E47225',
  dhcsYellow: '#F9A71C',
  dhcsOrangeDark: '#C57326',
  dhcsLinkBlue: '#005198',

  // Accent Colors (Including Fonts)
  dhcsAccentGray: '#ECEEF0',
  dhcsAccentYellow: '#FEEDD2'

}


export const buttonTheme = createMuiTheme({
  palette: {
    primary: {
      main: colors.dhcsBlue,
      light: colors.dhcsTeal,
      dark: colors.dhcsTealDark,
      contrastText: colors.dhcsWhite
    },
    secondary: {
      main: colors.dhcsOrange,
      light: colors.dhcsYellow,
      dark: colors.dhcsOrangeDark,
      contrastText: colors.dhcsWhite
    }
  }
})
